import { CounterpartyRole } from "../types/graphql-global-types";

const sortAgreementCounterparties = (formattedCounterparties: string | undefined): string => {
	if (!formattedCounterparties) return "";
	const buyers: Array<string> = [];
	const sellers: Array<string> = [];
	const observers: Array<string> = [];
	formattedCounterparties
		.split(",")
		.filter((v) => v.trim().length > 0)
		?.map((a: string) => {
			if (a.includes(`(${CounterpartyRole.BUYER})`)) {
				buyers.push(a);
			}
			if (a.includes(`(${CounterpartyRole.SELLER})`)) {
				sellers.push(a);
			}
			if (a.includes(`(${CounterpartyRole.OBSERVER})`)) {
				observers.push(a);
			}
		});
	const counterpartiesArray = [...buyers, ...sellers, ...observers];
	return counterpartiesArray.flatMap((e) => e.trimLeft()).join(", ");
};

export default sortAgreementCounterparties;
